export function isTotallyScrolled(el){return el?el.scrollHeight-el.scrollTop<=el.clientHeight:false}export default isTotallyScrolled;